import React, { Component } from "react";
import Chart from "chart.js";
import classes from "./Chart_Village_Species_BarChart.module.css";
import { stockData } from "../../assets/data";

var countAlligator = 0; var countAnteater = 0;
var countBear = 0; var countBird = 0; var countBull = 0;
var countCat = 0; var countChicken = 0; var countCow = 0; var countCub = 0;
var countDeer = 0; var countDog = 0; var countDuck = 0; 
var countEagle = 0; var countElephant = 0;
var countFrog = 0;
var countGoat = 0; var countGorilla = 0;
var countHamster = 0; var countHippo = 0; var countHorse = 0; 
var countKangeroo = 0; var countKoala = 0; 
var countLion = 0;
var countMonkey = 0; var countMouse = 0;
var countOctopus = 0; var countOstrich = 0;
var countPenguin = 0; var countPig = 0;
var countRabbit = 0; var countRhino = 0;
var countSheep = 0; var countSquirrel = 0;
var countTiger = 0; 
var countWolf = 0;

function getRandomColor() {
    var letters = '0123456789ABCDEF'.split('');
    var color = '#'; // '#'
    for (var i = 0; i < 6; i++ ) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}
var myColors_array = [];
var c;
for(c=0; c<35; c++) {
    var myColorResult = getRandomColor();
    myColors_array[c] = myColorResult;
    
}
console.log(myColors_array);

var myNumVillSpecies_array = [];
var myVillSpecies_array = [
        'Alligator', 'Anteater',
        'Bear', 'Bird', 'Bull',
        'Cat', 'Chicken', 'Cow', 'Cub',
        'Deer', 'Dog', 'Duck',
        'Eagle', 'Elephant',
        'Frog',
        'Goat', 'Gorilla',
        'Hamster', 'Hippo', 'Horse',
        'Kangaroo', 'Koala',
        'Lion',
        'Monkey', 'Mouse',
        'Octopus', 'Ostrich',
        'Penguin', 'Pig',
        'Rabbit', 'Rhino',
        'Sheep', 'Squirrel',
        'Tiger',
        'Wolf'   
    ];

stockData.map((data, key) => { 
    if (data.species.trim() == 'Alligator') {
        countAlligator = countAlligator + 1;
        myNumVillSpecies_array[0] = countAlligator;
    }
    if (data.species.trim() == 'Anteater') {
        countAnteater = countAnteater + 1;
        myNumVillSpecies_array[1] = countAnteater;
    } 
    if (data.species.trim() == 'Bear') {
        countBear = countBear + 1;
        myNumVillSpecies_array[2] = countBear;
    } 
    if (data.species.trim() == 'Bird') {
        countBird = countBird + 1;
        myNumVillSpecies_array[3] = countBird;
    }
    if (data.species.trim() == 'Bull') {
        countBull = countBull + 1;
        myNumVillSpecies_array[4] = countBull;
    } 
    if (data.species.trim() == 'Cat') {
        countCat = countCat + 1;
        myNumVillSpecies_array[5] = countCat;
    } 
    if (data.species.trim() == 'Chicken') {
        countChicken = countChicken + 1;
        myNumVillSpecies_array[6] = countChicken;
    } 
    if (data.species.trim() == 'Cow') {
        countCow = countCow + 1;
        myNumVillSpecies_array[7] = countCow;
    } 
    if (data.species.trim() == 'Cub') {
        countCub = countCub + 1;
        myNumVillSpecies_array[8] = countCub;
    } 
    if (data.species.trim() == 'Deer') {
        countDeer = countDeer + 1;
        myNumVillSpecies_array[9] = countDeer;
    } 
    if (data.species.trim() == 'Dog') {
        countDog = countDog + 1;
        myNumVillSpecies_array[10] = countDog;
    } 
    if (data.species.trim() == 'Duck') {
        countDuck = countDuck + 1;
        myNumVillSpecies_array[11] = countDuck;
    }    
    if (data.species.trim() == 'Eagle') {
        countEagle = countEagle + 1;
        myNumVillSpecies_array[12] = countEagle;
    }  
    if (data.species.trim() == 'Elephant') {
        countElephant = countElephant + 1;
        myNumVillSpecies_array[13] = countElephant;
    }  
    if (data.species.trim() == 'Frog') {
        countFrog = countFrog + 1;
        myNumVillSpecies_array[14] = countFrog;
    }  
    if (data.species.trim() == 'Goat') {
        countGoat = countGoat + 1;
        myNumVillSpecies_array[15] = countGoat;
    }  
    if (data.species.trim() == 'Gorilla') {
        countGorilla = countGorilla + 1;
        myNumVillSpecies_array[16] = countGorilla;
    }  
    if (data.species.trim() == 'Hamster') {
        countHamster = countHamster + 1;
        myNumVillSpecies_array[17] = countHamster;
    }  
    if (data.species.trim() == 'Hippo') {
        countHippo = countHippo + 1;
        myNumVillSpecies_array[18] = countHippo;
    } 
    if (data.species.trim() == 'Horse') {
        countHorse = countHorse + 1;
        myNumVillSpecies_array[19] = countHorse;
    }    
    if (data.species.trim() == 'Kangeroo') {
        countKangeroo = countKangeroo + 1;
        myNumVillSpecies_array[20] = countKangeroo;
    }  
    if (data.species.trim() == 'Koala') {
        countKoala = countKoala + 1;
        myNumVillSpecies_array[21] = countKoala;
    } 
    if (data.species.trim() == 'Lion') {
        countLion = countLion + 1;
        myNumVillSpecies_array[22] = countLion;
    } 
    if (data.species.trim() == 'Monkey') {
        countMonkey = countMonkey + 1;
        myNumVillSpecies_array[23] = countMonkey;
    } 
    if (data.species.trim() == 'Mouse') {
        countMouse = countMouse + 1;
        myNumVillSpecies_array[24] = countMouse;
    } 
    if (data.species.trim() == 'Octopus') {
        countOctopus = countOctopus + 1;
        myNumVillSpecies_array[25] = countOctopus;
    } 
    if (data.species.trim() == 'Ostrich') {
        countOstrich = countOstrich + 1;
        myNumVillSpecies_array[26] = countOstrich;
    } 
    if (data.species.trim() == 'Penguin') {
        countPenguin = countPenguin + 1;
        myNumVillSpecies_array[27] = countPenguin;
    } 
    if (data.species.trim() == 'Pig') {
        countPig = countPig + 1;
        myNumVillSpecies_array[28] = countPig;
    } 
    if (data.species.trim() == 'Rabbit') {
        countRabbit = countRabbit + 1;
        myNumVillSpecies_array[29] = countRabbit;
    } 
    if (data.species.trim() == 'Rhino') {
        countRhino = countRhino + 1;
        myNumVillSpecies_array[30] = countRhino;
    } 
    if (data.species.trim() == 'Sheep') {
        countSheep = countSheep + 1;
        myNumVillSpecies_array[31] = countSheep;
    } 
    if (data.species.trim() == 'Squirrel') {
        countSquirrel = countSquirrel + 1;
        myNumVillSpecies_array[32] = countSquirrel;
    } 
    if (data.species.trim() == 'Tiger') {
        countTiger = countTiger + 1;
        myNumVillSpecies_array[33] = countTiger;
    } 
    if (data.species.trim() == 'Wolf') {
        countWolf = countWolf + 1;
        myNumVillSpecies_array[34] = countWolf;
    } 
});
console.log('countAlligator: ' + countAlligator);
console.log('countWolf: ' + countWolf);

export default class VillagersSpecies_Chart extends Component {
    chartRef = React.createRef();

    componentDidMount() {
        const myChartRef = this.chartRef.current.getContext("2d"); 

        new Chart(myChartRef, {
            type: "bar",
            data: {
                //Bring in data
                labels: myVillSpecies_array, 
                datasets: [{
                    fillOpacity: 0.1,
                    label: 'Species Type',  
                    data: myNumVillSpecies_array,    		
                    backgroundColor: myColors_array,
                    borderColor: myColors_array,
                    borderWidth: 2,
                    fill: true,
                    lineTension: 0.3              
                  }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                  xAxes: [{
                      ticks: { 
                        beginAtZero: true,
                        autoSkip: false,
                        maxRotation: 90,
                        minRotation: 90  
                      }

                  }]  
                    
                }
              }
        });
    
    
    }
    render() {
        return (
            <div className={classes.graphContainer}>
                <canvas
                    id="myChart"
                    ref={this.chartRef}
                />
            </div>

        )
    }   
}    